function roundNumber(x) {
	return parseFloat(x.toFixed(2));
}

module.exports = roundNumber;
